import { useCallback, useEffect, useState } from 'react'

const useHiddenFormElement = (selector: string) => {
  const query = useCallback(() => document.querySelector(selector) as HTMLElement | null, [selector])

  const [element, setElement] = useState<HTMLElement | null>(query)
  useEffect(() => {
    const interval = setInterval(
      () => setElement((query()?.cloneNode(true) ?? null) as HTMLElement | null),
      100
    )
    return () => clearInterval(interval)
  }, [element, query])

  return element
}

export default useHiddenFormElement
